import styles from './styles.module.scss';

const LozengeCell = ({ value, color }) => {
  return (
    <div key={value} className={styles.lozenge} style={{ backgroundColor: color }}>
      {value}
    </div>
  );
};

export default LozengeCell;
